import cx from 'classnames';
import { AntdCheckbox, AntdSkeleton } from '@ui/components';

const OptionLoader = () => (
  <li className="mb-1 flex items-center">
    <AntdCheckbox className="large-checkbox pl-1" disabled></AntdCheckbox>
    <AntdSkeleton.Input block size="small" className="w-full mx-2" />
  </li>
);

type OptionsListLoaderProps = {
  isInfinite?: boolean;
  isNested?: boolean;
};

export const OptionsListLoader = ({ isNested, isInfinite }: OptionsListLoaderProps) => {
  return (
    <ul className={cx('list-none p-0 mt-1', isNested && 'ml-14', isInfinite && 'ml-4 mr-2')}>
      {Array.from({ length: isInfinite ? 5 : 10 }).map((_, index) => (
        <OptionLoader key={index} />
      ))}
    </ul>
  );
};
